module.exports = __webpack_public_path__ + "static/media/dkk-logo.5c342513.png";